/**
 * No operation function that does nothing and returns nothing.
 * Useful as a default callback or placeholder.
 */
export function noop(): void {}
